/**
 * @fileOverview 打印信息
 * @author kirkzheng
 * @time 2017-03-28
 */

const isSupportLog = typeof window.console != "undefined" && typeof window.console.log != "undefined"

/**
 * 打印信息
 * @param  {String} message 内容
 * @return {Void}
 */
export const log = (message = "") => {
  if (message && isSupportLog) {
    window.console.log(message)
  }
}

export default {
  log,
}
